module.exports = __webpack_public_path__ + "img/file-----------------------------------------------------bimistock--@1x.6c501f27.png";